import { render, staticRenderFns } from "../../../public/HODOPolicy/index.html?vue&type=template&id=dc1896f0&scoped=true&external"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"
import style0 from "../../../public/HODOPolicy/chinhsach_files/Site.css?vue&type=style&index=0&id=dc1896f0&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1896f0",
  null
  
)

export default component.exports